import enums from "./../enums";

export const handleError = ({ dispatch, loading, title, msg, cb }, e) => {
	if (loading) {
		dispatch({ type: loading, payload: false });
	}
	if (((e && e?.response?.status !== 401) || !e) && dispatch && title && msg) {
		let msgCode;
		if (e.response.data) {
			let { code } = e.response.data;
			msgCode = code;
		}
		dispatch({
			type: enums.ALERT_IN,
			payload: {
				type: "error",
				msg: msgCode ? msgCode : msg,
				title,
			},
		});
	} else {
		console.error("[ERR ]", e);
	}
	if (cb) {
		cb(e);
	}
};

export const showResponseErrorMessage = (e) => {
	if (e) {
		if (e.response) {
			if (e.response.data) {
				if (e.response.data.message) {
					return e.response.data.message;
				} else if (e.response.data.Message) {
					return e.response.data.Message;
				} else if (e.response.data.error) {
					return e.response.data.error;
				} else {
					return "GENERIC_ERROR";
				}
			} else {
				return "GENERIC_ERROR";
			}
		} else {
			return "GENERIC_ERROR";
		}
	} else {
		return "GENERIC_ERROR";
	}
};
